import React from 'react'
import { useGetQuestionsFromChildren } from './quiz/hooks'
import { useLoadProgress, useSetDefaultProgress, useSetQuestions } from './quiz/store'

function Widget(props) {
  const questions = useGetQuestionsFromChildren(props)

  useSetQuestions(props, questions)
  useSetDefaultProgress()
  useLoadProgress()

  return null
}

Widget.displayName = 'QuizWidget'

export default Widget